var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMalaysia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28648_37189)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_28648_37189",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00390625 0H24.0039V16H0.00390625V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_28648_37189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00390625 0H24.0039V16H0.00390625V0Z",
    fill: "#CC0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00390625 0H24.0039V1.14333H0.00390625V0Z",
    fill: "#CC0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00390625 1.14331H24.0039V2.28664H0.00390625V1.14331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00390625 2.28662H24.0039V3.42995H0.00390625V2.28662Z",
    fill: "#CC0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00390625 3.42993H24.0039V4.5666H0.00390625V3.42993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00390625 4.57007H24.0039V5.7134H0.00390625V4.57007Z",
    fill: "#CC0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00390625 5.71338H24.0039V6.85671H0.00390625V5.71338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00390625 6.85669H24.0039V8.00002H0.00390625V6.85669Z",
    fill: "#CC0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00390625 8H24.0039V9.14333H0.00390625V8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00390625 9.14331H24.0039V10.2866H0.00390625V9.14331Z",
    fill: "#CC0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00390625 10.2866H24.0039V11.43H0.00390625V10.2866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00390625 11.4299H24.0039V12.5666H0.00390625V11.4299Z",
    fill: "#CC0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00390625 12.5701H24.0039V13.7134H0.00390625V12.5701Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00390625 13.7134H24.0039V14.8567H0.00390625V13.7134Z",
    fill: "#CC0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00390625 14.8567H24.0039V16H0.00390625V14.8567Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00390625 0.0166016H12.0039V9.15993H0.00390625V0.0166016Z",
    fill: "#000066"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.28157 2.71485L7.46832 3.98673L8.18419 2.92423L7.79824 4.14923L8.90318 3.49923L8.02856 4.43673L9.30469 4.33673L8.1126 4.79923L9.30469 5.26173L8.02856 5.16173L8.90318 6.09924L7.79824 5.44923L8.18108 6.67736L7.4652 5.61174L7.27845 6.88361L7.09482 5.61174L6.37894 6.67424L6.76489 5.44923L5.65996 6.09924L6.53145 5.16173L5.25533 5.26173L6.45053 4.79923L5.25845 4.33673L6.53457 4.43673L5.65996 3.49923L6.76489 4.14923L6.37894 2.9211L7.09482 3.98673L7.28157 2.71485ZM6.24511 2.76797C5.90808 2.61743 5.53891 2.55387 5.17118 2.58306C4.80346 2.61225 4.44883 2.73326 4.13954 2.93511C3.83026 3.13695 3.57614 3.41321 3.40028 3.73877C3.22442 4.06434 3.13241 4.42887 3.13261 4.79923C3.13241 5.16959 3.22442 5.53413 3.40028 5.85969C3.57614 6.18525 3.83026 6.46152 4.13954 6.66336C4.44883 6.8652 4.80346 6.98622 5.17118 7.01541C5.53891 7.0446 5.90808 6.98103 6.24511 6.83049C5.873 7.09886 5.43435 7.25895 4.97746 7.29314C4.52056 7.32732 4.06313 7.23427 3.65551 7.02424C3.24836 6.81392 2.90686 6.49495 2.66854 6.10241C2.43022 5.70987 2.30433 5.25895 2.30469 4.79923C2.30484 4.33963 2.43118 3.88896 2.66982 3.49675C2.90846 3.10455 3.25017 2.78598 3.65739 2.57606C4.06462 2.36613 4.5216 2.27298 4.97812 2.30684C5.43463 2.3407 5.87302 2.50026 6.24511 2.76797Z",
    fill: "#FFCC00"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28648_37189"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "white",
    transform: "translate(0.00390625)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMalaysia);
export default __webpack_public_path__ + "static/media/Malaysia.745a44540ec92c68d1edfd058906b5de.svg";
export { ForwardRef as ReactComponent };